import React from "react";

export default function News() {
  return (
    <section id="about" className="about">
      <div className="container aos-init aos-animate" data-aos="fade-up">

        <div className="section-title">
          <h2>News & update</h2>
          <p>News & update</p>
        </div>

        <div className="row">
          <div className="col-lg-12 order-1 order-lg-2 aos-init aos-animate" data-aos="fade-left" data-aos-delay="100">
            {/* <img src="assets/img/about.jpg" className="img-fluid" alt="" /> */}
          </div>
          <div className="col-lg-12 pt-8 pt-lg-0 order-2 order-lg-3 content">
            <h3 style={{color: "orange", display: "flex", justifyContent: "center"}}>Coming soon</h3>
            {/* <p className="font-italic">
           
            </p> */}
            {/* <a href="" className="learn-more-btn">Learn More</a> */}
          </div>
        </div>

      </div>
    </section>
  );
}